import { render, staticRenderFns } from "./CustomViewRenderer.vue?vue&type=template&id=3c017e80&"
import script from "./CustomViewRenderer.vue?vue&type=script&lang=js&"
export * from "./CustomViewRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports